/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELResource,
  OTELResource$Outbound,
  OTELResource$outboundSchema,
} from "./otelresource.js";
import {
  OTELScopeLog,
  OTELScopeLog$Outbound,
  OTELScopeLog$outboundSchema,
} from "./otelscopelog.js";

/**
 * OTEL resource logs container
 */
export type OTELResourceLog = {
  /**
   * OTEL resource information
   */
  resource?: OTELResource | undefined;
  /**
   * Array of scope logs
   */
  scopeLogs?: Array<OTELScopeLog> | undefined;
};

/** @internal */
export type OTELResourceLog$Outbound = {
  resource?: OTELResource$Outbound | undefined;
  scopeLogs?: Array<OTELScopeLog$Outbound> | undefined;
};

/** @internal */
export const OTELResourceLog$outboundSchema: z.ZodMiniType<
  OTELResourceLog$Outbound,
  OTELResourceLog
> = z.object({
  resource: z.optional(OTELResource$outboundSchema),
  scopeLogs: z.optional(z.array(OTELScopeLog$outboundSchema)),
});

export function otelResourceLogToJSON(
  otelResourceLog: OTELResourceLog,
): string {
  return JSON.stringify(OTELResourceLog$outboundSchema.parse(otelResourceLog));
}
